import React from 'react';
import IntermodalStatusContainer from "@Intermodal/components/IntermodalStatusContainer";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import {isIntermodalRoute} from "@SearchResults/functions/isIntermodalRoute";
import SuggestedRouteType from "@Route/types/SuggestedRoute.type";
import RouteCompanyDetails from "@Route/features/company/components/RouteCompanyDetails";
import RouteStatusContainer from "@Route/features/status/components/RouteStatusContainer";
import ParamsType from "@SearchResults/types/params/Params.type";
import {isSuggestedRoute} from "@SearchResults/functions/isSuggestedRoute";
import DebugApiRouteInfo from "@Features/debug/components/DebugApiRouteInfo";
import useShowApiFullIntegrationRouteDebugPopover
    from "@Features/debug/hooks/useShowApiFullIntegrationRouteDebugPopover";
import useIsMobile from "@Hooks/selector/useIsMobile";
import RouteStationsInfo from "@Route/components/Container/RouteStationsInfo";
import useIsSmallTablet from "@Hooks/selector/useIsSmallTablet";

interface RouteItemContainerProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType,
    activeHub?: string,
    params: ParamsType
    isReturn: boolean,
}

function RouteItemContainer(props: RouteItemContainerProps) {
    const {
        route,
        activeHub,
        isReturn,
        params,
    } = props

    const showDebug = useShowApiFullIntegrationRouteDebugPopover(route)
    const isMobile = useIsMobile()
    const isSmallTablet = useIsSmallTablet()

    return (
        <>
            {isMobile || isSmallTablet ? (
                <div className="gb--route-stations-container">
                    <RouteStationsInfo
                        route={route}
                        activeHub={activeHub}
                    />
                </div>
            ) : (
                <RouteStationsInfo
                    route={route}
                    activeHub={activeHub}
                />
            )}
            {(isIntermodalRoute(route) || isSuggestedRoute(route)) ? (
                <IntermodalStatusContainer
                    baseRoutes={route.baseRoutes}
                    busChangeCount={route.travelInfo.busChangeCount}
                />
            ) : (
                <RouteCompanyDetails
                    route={route}
                />
            )}
            <RouteStatusContainer
                isReturn={isReturn}
                params={params}
                route={route}
            />
            {showDebug && (
                <DebugApiRouteInfo
                    route={props.route}
                />
            )}
        </>
    );
}

export default RouteItemContainer